import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { patch, post, del } from '../../api/api';
import { IEtapasTunnel } from '../modelos/IParametrosIntegracao';

export const createTunnelToken = async (payload: any): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(`/cloudflare/tunnel/cria-tunnel`, payload);
};

export const refreshTunnel = async (
  tunnelId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/cloudflare/tunnel/${tunnelId}/refresh-tunnel`,
    payload
  );
};

export const validateConnector = async (
  tunnelId: string,
  connectorId: string
): Promise<IRespostaFuncao<any>> => {
  return await post(`/cloudflare/tunnel/${tunnelId}/valida-connector/${connectorId}`, {});
};

export const configuraTunnel = async (
  tunnelId: string,
  host: string,
  porta: number,
  tunnelName: string
): Promise<IRespostaFuncao<any>> => {
  return await post(`/cloudflare/tunnel/${tunnelId}/configura-tunnel-service`, {
    host,
    porta,
    tunnelName
  });
};

export const atualizaEtapasTunnel = async (
  tunnelId: string,
  etapas: IEtapasTunnel
): Promise<IRespostaFuncao<any>> => {
  return await post(`/cloudflare/tunnel/${tunnelId}/atualiza-etapas`, etapas);
};

export const deleteTunnel = async (
  tunnelId: string,
  empId: string,
  tunnelName: string
): Promise<IRespostaFuncao<any>> => {
  return await del(`/cloudflare/tunnel/${tunnelId}`, {
    data: { empId, tunnelName }
  });
};
